export const flashComponentMetaData = {
    isRepeatable: false
}
